module.exports = __webpack_public_path__ + "img/superman_shrugs.8d313179.jpg";